module.exports = __webpack_public_path__ + "img/MyPoz.bc9d0b7b.png";